import { render, staticRenderFns } from "./GameControls.vue?vue&type=template&id=75f3cdf5&scoped=true&"
import script from "./GameControls.vue?vue&type=script&lang=js&"
export * from "./GameControls.vue?vue&type=script&lang=js&"
import style0 from "./GameControls.vue?vue&type=style&index=0&id=75f3cdf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f3cdf5",
  null
  
)

export default component.exports